import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import useTable from "../../../../components/useTable";
//UI
import {
  Checkbox,
  Input,
  Radio,
  SearchInput,
} from "../../../../ui/inputs/Input";
import { DangerButton, SuccessButton, WarningButton, PrimaryButton } from "../../../../ui/buttons/Button";

const headCells = [
  {
    id: "codOtroPago",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Cod. Otro Pago",
    textAlign: "center",
  },
  {
    id: "descripcion",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Descripción",
    textAlign: "center",
  },
  {
    id: "numCuotas",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Num. Cuotas",
    textAlign: "center",
  },
  {
    id: "Monto",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Monto",
    textAlign: "center",
  },
];

export default function OtrosPrestamos({ show, setShow, setTabla }) {
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead, recordsAfterPagingAndSorting } = useTable(
    records,
    headCells,
    filterFn
  );

  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  return (
    <Modal size="xl" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Seleccionar Tipo de Pago</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap align-items-center">
        <div className="col-3 m-0 mb-2 p-0">
          <SearchInput label="Cod. Integrante:" />
        </div>
        <div className="col-9 m-0 mb-2 p-0 pl-2">
          <Input label="Nombre:" />
        </div>
        <div className="col-3 m-0 mb-2 p-0">
          <SearchInput label="Cod. Concepto:" />
        </div>
        <div className="col-9 m-0 mb-2 p-0 pl-2">
          <Input label="Descripción:" />
        </div>
        <div className="col-3 m-0 mb-2 p-0">
          <Input
            label="Monto del Prestamo:"
            inputClassName="text-end"
            placeholder="0.00"
          />
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input
            label="Monto de Descuento:"
            inputClassName="text-end"
            placeholder="0.00"
          />
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input label="Saldo:" inputClassName="text-end" placeholder="0.00" />
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Checkbox label="Caja de Ahorros" id="cajaAhorros" />
        </div>
        <div className="col-6 m-0 p-0 d-flex gap-2 align-items-center">
          <div className="col-auto m-0 mb-2 p-0">
            <Checkbox label="Activo" id="activo" />
          </div>
          <fieldset className="col m-0 p-2 d-flex gap-2 flex-wrap border-azul rounded">
            <legend className="w-auto float-none m-0">
              Descuento Vacaciones
            </legend>
            <div className="col-auto m-0 p-0">
              <Checkbox label="Período 1" id="peridodo1" />
            </div>
            <div className="col-auto m-0 p-0">
              <Checkbox label="Período 2" id="peridodo2" />
            </div>
            <div className="col-auto m-0 p-0">
              <Checkbox label="Período 3" id="peridodo3" />
            </div>
            <div className="col-auto m-0 p-0">
              <Checkbox label="Período 4" id="peridodo4" />
            </div>
            <div className="col-auto m-0 p-0">
              <Checkbox label="Período 5" id="peridodo5" />
            </div>
          </fieldset>
        </div>
        <div className="col-6 m-0 p-0 d-flex pl-2">
          <fieldset className="col m-0 p-2 d-flex gap-2 border-azul rounded">
            <legend className="w-auto float-none m-0">
              Descuento Vacaciones
            </legend>
            <div className="col-auto m-0 p-0">
              <Radio
                label="Por Cuotas"
                name="descuentoVacaciones"
                id="descuentoVacaciones1"
              />
            </div>
            <div className="col-auto m-0 p-0">
              <Radio
                label="Por Monto"
                name="descuentoVacaciones"
                id="descuentoVacaciones2"
              />
            </div>
            <div className="col m-0 p-0">
              <Input label="Num. Cuotas:" />
            </div>
            <div className="col m-0 p-0">
              <Input
                label="Monto"
                inputClassName="text-end"
                placeholder="0.00"
              />
            </div>
          </fieldset>
        </div>
        <div className="col-12 m-0 mt-2 p-0 d-flex ">
          <div className="col-11 m-0 p-0">
            <TblContainer>
              <TblHead />
              <tbody>
                {records &&
                  recordsAfterPagingAndSorting().map((item, index) => (
                    <tr key={index}></tr>
                  ))}
              </tbody>
            </TblContainer>
          </div>
          <div className="col-1 m-0 mb-2 p-0 d-flex flex-column gap-2 align-items-center justify-content-center">
            <div className="col-auto m-0 p-0">
              <PrimaryButton icon="fa-plus m-0" />
            </div>
            <div className="col-auto m-0 p-0">
              <WarningButton icon="fa-edit m-0" />
            </div>
            <div className="col-auto m-0 mb-2 p-0">
              <DangerButton icon="fa-trash-alt m-0" />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton>Aceptar</SuccessButton>
        <DangerButton>Cancelar</DangerButton>
      </Modal.Footer>
    </Modal>
  );
}
